import React, { Component } from 'react';
import Service from '../helpers/service';
import Helping from "../helpers/Helping";
import { setErrorFields, validateField } from "../helpers/validationHelpers";
import Notification from "./layout/Notification";
import LoadingButton from './fields/LoadingButton';
import { MESSAGE } from "../config/index";
import { trackPromise } from 'react-promise-tracker';
import { Link } from 'react-router-dom';
import { API_URL } from '../config/urls';

const { UPDATE, EMPTY, REQUIRE } = MESSAGE;
class ChangePassword extends Component {
    constructor(props) {
        super(props);

        this.state = {
            pageTitle: 'Change password',
            buttonTitle: 'Update',
            old_password: '',
            new_password: '',
            re_password: '',
            url: API_URL.ADMIN_API + 'admin/change-password',
            routeName: '/change-password',
            error_message: '',
            error_type: '',
            isLoading: false,
            btnIsEnable: false,
        };

        this.onUpdate = this.onUpdate.bind(this);
        this.handleOldPasswordChange = this.handleOldPasswordChange.bind(this);
        this.handleNewPasswordChange = this.handleNewPasswordChange.bind(this);
    }

    async handleOldPasswordChange(e) {
        this.setState({
            old_password: e.target.value
        }, this.setState({ ...await validateField("string", e.target.name, e.target.value) }));
    }

    async handleNewPasswordChange(e) {
        this.setState({
            new_password: e.target.value
        }, this.setState({ ...await validateField("string", e.target.name, e.target.value) }));
    }

    async handleConfirmPasswordChange(e) {
        this.setState({
            re_password: e.target.value
        }, this.setState({ ...await validateField("string", e.target.name, e.target.value) }));
    }

    removeNetworkError = () => {
        this.setState({ ...Helping.clearNetworkRequest() });
    }

    checkEmptyFields = () => {
        let { state } = this,
            formHasError = false;

        if (state.old_password.length === 0) {
            let errorObject = setErrorFields("oldpassword", Helping.getMessageString(REQUIRE, "Old Password"));
            this.setState({ ...errorObject });
            formHasError = true;
        }

        if (state.new_password.length === 0) {
            let errorObject = setErrorFields("newpassword", Helping.getMessageString(REQUIRE, "New Password"));
            this.setState({ ...errorObject });
            formHasError = true;
        }

        if (state.re_password.length === 0) {
            let errorObject = setErrorFields("re_password", Helping.getMessageString(EMPTY, "Confirm Password"));
            this.setState({ ...errorObject });
            formHasError = true;
        }

        return formHasError;
    }

    onUpdate(e) {
        e.preventDefault();

        let self = this,
            formHasError = this.checkEmptyFields();
        if (formHasError) {
            window.scrollToErrorFields();
            return;
        }

        if (self.state.new_password !== self.state.re_password) {
            self.setState({
                error_message: "Confirm Password is not same to New Password",
                error_type: 'danger'
            });
            return;
        }
        let validationFailed = Helping.passwordValidation(this.state.new_password);

        if (validationFailed) {
            self.setState({
                error_message: "Your password must include an uppercase letter, a symbol and be 7 or more characters long.",
                error_type: 'danger'
            })
            return;
        }

        this.setState({
            btnIsEnable: true,
            error_message: ""
        });

        let data = {
            oldPassword: self.state.old_password,
            newPassword: self.state.new_password
        };

        trackPromise(
            Service.postCall(self.state.url, data).then(response => {
                self.setState({
                    error_message: Helping.getMessageString(UPDATE, "password"),
                    error_type: 'success',
                    btnIsEnable: false
                },
                    () => {
                        delete localStorage.token
                        delete localStorage.profile
                    }
                );
                self.resetForm();
            })
                .catch(error => {
                    console.log(error.response);
                    if (error.response) {
                        Helping.redirectToLogin(error);
                        return self.setState({
                            error_message: error.response.data.message,
                            error_type: 'danger',
                            btnIsEnable: false
                        });
                    }
                    return this.setState({
                        btnIsEnable: false,
                        ...Helping.setNetworkRequestError(error, "password update")
                    })
                })
        )
    }

    resetForm = () => {
        this.setState({
            old_password: '',
            new_password: '',
            re_password: ''
        });
    }

    render() {
        return (
            <div class="content create-json">
                <div class="top-header">
                    <div class="header-title">
                        <h2 class="title">Change Password</h2>
                        <span class="title-caption">You can change your password now.</span>
                    </div>
                    <div class="header-btn">
                        <Link to="/dashboard" class="custom-btn dark-btn icon-btn sm-btn">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15.5" height="12.117" viewBox="0 0 15.5 12.117">
                                <g id="Arrow_-_Left" data-name="Arrow - Left" transform="translate(0.75 1.059)">
                                    <g id="Arrow_-_Left-2" data-name="Arrow - Left" transform="translate(14) rotate(90)">
                                        <path id="Stroke_1" data-name="Stroke 1" d="M0,14V0" transform="translate(5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" />
                                        <path id="Stroke_3" data-name="Stroke 3" d="M10,0,5,5.647,0,0" transform="translate(0 8.353)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" />
                                    </g>
                                </g>
                            </svg>
                            <span class="txt-btn">Back</span>
                        </Link>
                    </div>
                </div>
                <div class="main-content">
                    {this.state.error_message &&
                        <Notification
                            type={this.state.error_type}
                            message={this.state.error_message}
                            callback={this.removeNetworkError}
                        />
                    }
                    <form action="" class="json-form" onSubmit={this.onUpdate}>
                        <div class="form-group">
                            <label for="oldpwd">Old Password</label>
                            <input type="password" name="oldpassword" id="oldpwd" class={`form-control ${this.state.error_oldpassword_message ? 'error-input' : ''}`} value={this.state.old_password} onChange={(e) => this.handleOldPasswordChange(e)} />
                            <span className="error-msg">{this.state.error_oldpassword_message}</span>
                        </div>
                        <hr class="divider"></hr>

                        <div class="form-group">
                            <label for="newpwd">New Password</label>
                            <input type="password" name="newpassword" id="newpwd" class={`form-control ${this.state.error_newpassword_message ? 'error-input' : ''}`} value={this.state.new_password} onChange={(e) => this.handleNewPasswordChange(e)} />
                            <div class="cpwd-info">Must contain an uppercase letter, a symbol and be 7 or more characters long.</div>
                            <span className="error-msg">{this.state.error_newpassword_message}</span>
                        </div>

                        <div class="form-group">
                            <label for="confirmpwd">Confirm New Password</label>
                            <input type="password" name="re_password" id="confirmpwd" class={`form-control ${this.state.error_re_password_message ? 'error-input' : ''}`} value={this.state.re_password} onChange={(e) => this.handleConfirmPasswordChange(e)} />
                            <span className="error-msg">{this.state.error_re_password_message}</span>
                        </div>

                        <div class="content-btn">
                            <button type="reset" class="custom-btn sm-btn semi-dark-btn border-btn" onClick={this.resetForm}>Reset</button>
                            {this.state.btnIsEnable ?
                                <LoadingButton class_name={"sm-btn"} />
                                :
                                <button type="submit" class="custom-btn sm-btn gradiant-btn" onClick={(e) => this.onUpdate(e)}>{this.state.btnIsEnable ? "Loading..." : "Update"}</button>
                            }
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}

export default ChangePassword;